import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, EffectFade, Navigation } from 'swiper';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/pc/');

SwiperCore.use([EffectFade]);

export default function Comp() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');

    const swiperMap: any = {
        us: ['animC1', 'animC2', 'animC3'],
        kr: ['animC1_kr', 'animC2_kr', 'animC3_kr'],
    };

    const swiperList = swiperMap[locale] || swiperMap.us;
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationC .msg-box1',
            offset: layoutH * 0.1, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '20%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationC .msg-box1',
            0.3,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );
        sceneA1.setTween(tweenA1);
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationC} animationC GtmModuleData-section`} data-section-id={css.animationC} data-section-title={t('delta2.aniC_box1_msg2')}>
            <div className="static-box">
                <div className="msg-box1">
                    <div className="msg-title1">{t('delta2.aniC_box1_msg1')}</div>
                    <div className="msg-title2 title-bolder">{t('delta2.aniC_box1_msg2')}</div>
                    <div className="msg-desc">{t('delta2.aniC_box1_msg3')}</div>
                </div>
                <Swiper
                    modules={[Autoplay, Navigation]}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    className="animationC-swiper"
                    slidesPerView={'auto'}
                    initialSlide={0}
                    loop={true}
                    observer={true}
                    observeParents={true}
                    preloadImages={false}
                    lazy={true}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={0}
                    centeredSlides={true}
                    grabCursor={true}
                    speed={800}
                >
                    {swiperList.map((item: any, k: number) => (
                        <SwiperSlide key={k}>
                            <EFPic className="animationC-img" name={[`${item}.webp`, `${item}.jpg`]} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
